/* eslint-disable */

/** unique or primary key constraints on table "argo.role_acl" */
export enum ArgoRoleAclConstraint {
  /** unique or primary key constraint on columns "role_acl_id" */
  RoleAclPkey = 'role_acl_pkey',
  /** unique or primary key constraint on columns "role_id", "acl_id" */
  RoleAclRoleIdAclIdKey = 'role_acl_role_id_acl_id_key'
}

/** select columns of table "argo.role_acl" */
export enum ArgoRoleAclSelectColumn {
  /** column name */
  AclId = 'acl_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id'
}

/** update columns of table "argo.role_acl" */
export enum ArgoRoleAclUpdateColumn {
  /** column name */
  AclId = 'acl_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RoleId = 'role_id'
}

